import React from 'react';
import { Button, Card, CardBody, CardTitle, Col, FormGroup, Input, Label, Row } from 'reactstrap';
import { mdiFileMultiple } from '@mdi/js';
import Icon from '@mdi/react';
import { toast } from 'react-toastify';

const EmbeddedCodeSection = ({ embeddedCode, embeddedCodeActual }) => {
    const handleCopy = (code) => {
        // Copy the actual working code (with encoded HTML), not the display version
        const codeToCopy = embeddedCodeActual || embeddedCode || code;
        navigator.clipboard.writeText(codeToCopy);
        toast.success('Embedded code copied to clipboard!');
    };

    return (
        <Card className="mb-4">
            <CardBody>
                <CardTitle tag="h5" style={{ color: "#6691e7" }}>Embedded Code</CardTitle>
                <hr />
                <FormGroup>
                    <Label for="embeddedCode">Embedded Code (Iframe)</Label>
                    <Row>
                        <Col md={10}>
                            <Input
                                type="textarea"
                                id="embeddedCode"
                                rows="4"
                                value={embeddedCode}
                                readOnly
                                className="form-control"
                                style={{ fontFamily: 'monospace', fontSize: '12px' }}
                            />
                        </Col>
                        <Col md={2}>
                            <Button
                                style={{ backgroundColor: 'white', borderColor: 'white' }}
                                onClick={handleCopy}
                                className="d-flex align-items-center"
                                disabled={!embeddedCode}
                                title="Copy Iframe Code (copies full working code)"
                            >
                                <Icon path={mdiFileMultiple} size={1} color="#6ada7d" />
                            </Button>
                        </Col>
                    </Row>
                </FormGroup>
            </CardBody>
        </Card>
    );
};

export default EmbeddedCodeSection;

